export default "__VITE_ASSET__C6ytq59m__"